import { AfterViewInit, Component, ElementRef, Input, OnDestroy, ViewChild } from '@angular/core';
import { AjaxService } from 'AjaxService';
import { IBemerkungenViewModel } from './bemerkungen.component';
import { bereinigterInhalt, textAlsHtml } from './bemerkungen-html.model';

@Component({
  selector: 'cz-bemerkungen-html-ansicht', standalone: false,
  template: `
    <p *ngIf="laden" role="status">Bilder werden geladen …</p>
    <div *ngIf="fehler" class="alert alert-danger" role="alert">{{ fehler }}
      <button type="button" class="btn btn-default" (click)="anzeigen()">Erneut laden</button>
    </div>
    <div #inhalt class="bemerkung-inhalt"></div>
  `,
  styleUrls: ['./bemerkungen-html.component.css']
})
export class BemerkungenHtmlAnsichtComponent implements AfterViewInit, OnDestroy {
  @Input() bemerkung: IBemerkungenViewModel;
  @ViewChild('inhalt', { static: true }) inhalt: ElementRef<HTMLDivElement>;
  laden = true;
  fehler = '';
  private urls = new Map<string, string>();
  private beendet = false;

  constructor(private ajax: AjaxService) {}
  ngAfterViewInit() { queueMicrotask(() => { if (!this.beendet) void this.anzeigen(); }); }

  async anzeigen() {
    this.laden = true;
    this.fehler = '';
    try {
      for (const bild of this.bemerkung.bilder || []) {
        if (this.urls.has(bild.bildId)) continue;
        const blob = await this.ajax.downloadResource(`api/Bemerkungen/${this.bemerkung.id}/Bilder/${bild.bildId}`);
        if (this.beendet) return;
        this.urls.set(bild.bildId, URL.createObjectURL(blob));
      }
      if (this.beendet) return;
      const dom = bereinigterInhalt(this.bemerkung.textHtml ?? textAlsHtml(this.bemerkung.text), this.urls);
      this.inhalt.nativeElement.replaceChildren(...Array.from(dom.childNodes));
      await Promise.all(Array.from(this.inhalt.nativeElement.querySelectorAll('img')).map(img => img.decode()));
    } catch {
      this.fehler = 'Die Bemerkung konnte nicht vollständig geladen werden. Bitte versuchen Sie es erneut.';
    } finally { this.laden = false; }
  }

  ngOnDestroy() {
    this.beendet = true;
    this.urls.forEach(url => URL.revokeObjectURL(url));
    this.urls.clear();
  }
}
